import { Github, Linkedin, Twitter } from "lucide-react";

export default function Navbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/80 backdrop-blur-md border-b border-[#252530]">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#00d4aa] to-[#6ee7c2] flex items-center justify-center text-[#0a0a0f] font-bold text-lg">
              C
            </div>
            <span className="text-[#f0f0f5] font-semibold text-lg" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Chethan.dev
            </span>
          </div>
          
          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className="nav-link text-[#a0a0b0] hover:text-[#f0f0f5] transition-colors text-sm font-medium">
              About
            </a>
            <a href="#work" className="nav-link text-[#a0a0b0] hover:text-[#f0f0f5] transition-colors text-sm font-medium">
              Work
            </a>
            <a href="#contact" className="nav-link text-[#a0a0b0] hover:text-[#f0f0f5] transition-colors text-sm font-medium">
              Contact
            </a>
          </div>
          
          {/* Right side */}
          <div className="flex items-center gap-4">
            {/* Social Icons */}
            <div className="hidden sm:flex items-center gap-3">
              <a 
                href="https://github.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#a0a0b0] hover:text-[#00d4aa] transition-colors"
                data-testid="social-github"
              >
                <Github className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#a0a0b0] hover:text-[#00d4aa] transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#a0a0b0] hover:text-[#00d4aa] transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            
            {/* Get in touch button */}
            <button 
              className="px-5 py-2 bg-gradient-to-r from-[#00d4aa] to-[#6ee7c2] text-[#0a0a0f] text-sm font-semibold rounded-lg hover:opacity-90 transition-all glow-cyan-sm"
              data-testid="get-in-touch-btn"
            >
              Get in touch
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
